// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__3kAbV","productName":"Table_productName__3D1_u"};